import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
// Components
import Dialog from 'components/Dialog';
import Video from 'components/Video';

type Props = {
  onClose: () => void;
}

const PromoVideoDialog:FC<Props> = ({
  // Props
  onClose
}) => {
  // State
  const quiz:any = useAppSelector(selectQuiz);

  return (
    <Dialog
      background={`linear-gradient(45deg, ${quiz.primaryColor} 0%, ${quiz.secondaryColor} 65%, ${quiz.tertiaryColor} 100%)`}
    >
      <Video
        videoUrl={quiz.promoVideo}
        onEndedCallback={onClose}
      />
    </Dialog>
  )
}

export default PromoVideoDialog;
